import { all, call, takeEvery, put, fork } from "redux-saga/effects";
// import { push } from "react-router-redux";
import { getToken, getProfile, clearToken } from "../../helpers/utility";
import actions from "./actions";
import appActions from "../app/actions";
import API from "../../helpers/API";
import Notification from "../../components/notification";

export function* loginRequest() {
  yield takeEvery("LOGIN_REQUEST", function* (action) {
    try {
      const login = yield call(API.auth.login, action.payload);
      if (action.payload.rememberme) {
        localStorage.setItem("cachedUsername", action.payload.username || action.payload.email);
        localStorage.setItem("cachedUserId", action.payload.password);
      }
      const loginPayload = login && login.data && login.data.data ? login.data.data : login && login.data ? login.data : login;
      const accessToken = loginPayload && (loginPayload.accessToken || loginPayload.token);
      const profile = loginPayload && (loginPayload.user || loginPayload.profile);
      if (accessToken) {
        yield put({
          type: appActions.CHANGE_CURRENT,
          current: ["dashboard"],
        });
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: accessToken,
          profile,
        });
        localStorage.setItem("userLoginTime", new Date());
        localStorage.setItem("userData", JSON.stringify(profile));
        if (typeof action.spinHandler === "function") {
          yield call(action.spinHandler, false);
        }
        window.location.href = "/dashboard/home";
      } else {
        yield put({ type: actions.LOGIN_ERROR });
      }
    } catch (err) {
      yield call(action.spinHandler, false);
      Notification(
        "error",
        err && err.error ? err.error?.message || err.message || err.error : "Invalid login"
      );
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem("id_token", payload.token);
    yield localStorage.setItem("profile", JSON.stringify(payload.profile));
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () { });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    try {
      // yield call(API.auth.logout);
      clearToken();
      window.location.href = "/";
    } catch (err) {
      Notification("error", "Session timed out. Please login again");
    }
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
    const { idToken } = getToken();
    const { profile } = getProfile();
    if (idToken) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: idToken,
        profile,
      });
    }
  });
}

export function* updateProfile() {
  yield takeEvery(actions.UPDATE_PROFILE, function* (payload) {
    const { idToken } = getToken();
    const { profile } = getProfile();
    if (profile) {
      profile.avatar = payload.avatar ? payload.avatar : "";
    }
    if (idToken) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: idToken,
        profile,
      });
    }
  });
}

export function* updateUserData() {
  yield takeEvery(actions.UPDATE_USER_DATA_UPDATE, function* (payload) {
    yield put({
      type: actions.UPDATE_USER_DATA,
      payload, // This should contain the updated profile data
    });
  });
}

export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(updateProfile),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
    fork(updateUserData),
  ]);
}
